import React, {useState} from "react";
import {motion} from "framer-motion";
import TypewriterText from "./TypewriterText";
import FlightAnimation from "./FlightAnimation";
import styles from "../../Parigi.module.css";

const POSTCARD_TEXT = "Con il buio o sotto la pioggia. Dall'ora più scura di una eclisse al sole accecante del mezzogiorno. Dalla siccità dell'estate al freddo inverno. In ogni tempo e luogo vorrò star insieme a te - auguri amore!";

const Postcard = () => {
    const [showFlight, setShowFlight] = useState(false);

    return (
        <motion.div
            key="postcard"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.8}}
            className={styles.postcardWrapper}
        >
            <div className={styles.postcardCard}>
                <TypewriterText
                    text={POSTCARD_TEXT}
                    onDone={() => setTimeout(() => setShowFlight(true), 500)}
                />
                {showFlight && <FlightAnimation/>}
            </div>
        </motion.div>
    );
};

export default Postcard;
